import "./contact-card-block.scss";